export function setTaskIcon(default_action_type) {
  let taskIcon;

  switch (default_action_type) {
    case null:
    case undefined:
    case "":
      taskIcon = "other-tasks-circle";
      break;
    case "OTHER":
      taskIcon = "other-tasks-circle";
      break;
    default:
      taskIcon = `${default_action_type.toLowerCase()}-circle`;
  }

  return taskIcon;
}
